/** Display-only helpers. Never mutate stored values. */

export function fullDisplayNumber(value) {
	if (value === null || value === undefined || value === '') return '0'
	const num = Number(value)
	if (!Number.isFinite(num)) return String(value)
	return String(num)
}

/**
 * Shorten long decimals for screen viewing, e.g. 2.083329916000366 → 2.083...
 * @param {number|string} value
 * @param {number} maxDecimals
 * @returns {{ short: string, full: string, truncated: boolean }}
 */
export function truncateDisplayNumber(value, maxDecimals = 3) {
	const full = fullDisplayNumber(value)
	const num = Number(value)
	if (!Number.isFinite(num)) {
		return { short: full, full, truncated: false }
	}

	const str = String(num)
	const dot = str.indexOf('.')
	if (dot === -1) {
		return { short: str, full: str, truncated: false }
	}

	const decimals = str.slice(dot + 1)
	if (decimals.length <= maxDecimals) {
		return { short: str, full: str, truncated: false }
	}

	return {
		short: `${str.slice(0, dot + 1 + maxDecimals)}...`,
		full: str,
		truncated: true,
	}
}

export function formatShortNumber(value, maxDecimals = 3) {
	return truncateDisplayNumber(value, maxDecimals).short
}
